var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from "react";
import { PremiseProvider, PremiseType } from "../../../__generated__/graphql-global-types";
import { isRequestDataValid, isUserCountValid } from "../../models/Premise";
import { useAnalytics } from "../../analytics";
import { isRepoValid } from "../../components/RepoValidationMessage";
export var usePremise = function (wargameTemplate, setWargameTemplate) {
    var _a, _b;
    var premise = (_b = (_a = wargameTemplate.premise) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
    var setPremise = function (premise) {
        return setWargameTemplate(function (prev) { return (__assign(__assign({}, prev), { premise: !premise ? null : [premise] })); });
    };
    var _c = __read(useState(null), 2), premiseBeingEdited = _c[0], setPremiseBeingEdited = _c[1];
    var startEditing = function () {
        setPremiseBeingEdited(getPremiseToEdit(premise));
    };
    var stopEditing = function () {
        setPremiseBeingEdited(null);
    };
    var isPremiseFormWizardButtonDisabled = premiseBeingEdited !== null;
    var sendUIEvent = useAnalytics().sendUIEvent;
    var submit = function () {
        if (!premiseBeingEdited || !isPremiseValid(premiseBeingEdited)) {
            return;
        }
        var basePremise = {
            provider: premiseBeingEdited.provider,
            inputType: premiseBeingEdited.inputType,
            inputData: {
                user_count: premiseBeingEdited.inputData.user_count,
                steady_state_time: premiseBeingEdited.inputData.steady_state_time,
                ramp_up_time: premiseBeingEdited.inputData.ramp_up_time,
                custom_env_variables: premiseBeingEdited.inputData.custom_env_variables
            }
        };
        var inputData = basePremise.inputData;
        if (premiseBeingEdited.inputType === PremiseType.perfhammer_apis) {
            inputData.apis = premiseBeingEdited.inputData.apis;
            inputData.request_method = premiseBeingEdited.inputData.request_method;
            if (isRequestDataValid(premiseBeingEdited)) {
                inputData.request_data = premiseBeingEdited.inputData.request_data;
            }
        }
        else if (premiseBeingEdited.inputType === PremiseType.perfhammer_scripts) {
            inputData.repo = premiseBeingEdited.inputData.repo
                ? premiseBeingEdited.inputData.repo
                : "git@bitbucket.org:atlassian/resilience-lg.git";
            inputData.script_name = premiseBeingEdited.inputData.script_name;
            inputData.branch = premiseBeingEdited.inputData.branch;
        }
        else if (premiseBeingEdited.inputType === PremiseType.perfhammer_sqs) {
            inputData.queue_url = premiseBeingEdited.inputData.queue_url;
            inputData.request_data = premiseBeingEdited.inputData.request_data;
        }
        sendUIEvent({
            source: "createWargamePlanPremiseSetupStep",
            actionSubject: "button",
            action: "clicked",
            actionSubjectId: "premiseSetup",
            attributes: {
                premise: basePremise
            }
        });
        setPremise(basePremise);
        stopEditing();
    };
    var deletePremise = function () {
        setPremise(null);
    };
    return {
        premise: premise,
        premiseBeingEdited: premiseBeingEdited,
        setPremiseBeingEdited: setPremiseBeingEdited,
        startEditing: startEditing,
        stopEditing: stopEditing,
        isPremiseFormWizardButtonDisabled: isPremiseFormWizardButtonDisabled,
        submit: submit,
        deletePremise: deletePremise
    };
};
export var isPremiseValid = function (premise) {
    if (!premise) {
        return true;
    }
    if (!isUserCountValid(premise)) {
        return false;
    }
    switch (premise.inputType) {
        case PremiseType.perfhammer_apis:
            return (!!premise.inputData.apis &&
                !!premise.inputData.request_method &&
                (premise.inputData.request_method === "GET" ||
                    !!premise.inputData.request_data));
        case PremiseType.perfhammer_scripts:
            return (!!premise.inputData.script_name &&
                !!premise.inputData.branch &&
                !!isRepoValid(premise.inputData.repo));
        case PremiseType.perfhammer_sqs:
            return !!premise.inputData.queue_url && !!premise.inputData.request_data;
        default:
            return false;
    }
};
export var getPremiseToEdit = function (premise) {
    if (premise) {
        return premise;
    }
    var DEFAULT_RAMPUP_TIME = 180;
    var DEFAULT_SS_TIME = 3600;
    var DEFAULT_REPO = "git@bitbucket.org:atlassian/resilience-lg.git";
    return {
        inputType: PremiseType.perfhammer_apis,
        provider: PremiseProvider.perfhammer,
        inputData: {
            apis: "",
            script_name: "",
            repo: DEFAULT_REPO,
            branch: "",
            queue_url: "",
            ramp_up_time: DEFAULT_RAMPUP_TIME,
            steady_state_time: DEFAULT_SS_TIME,
            request_method: "GET"
        }
    };
};
